








import { Component, Vue } from "vue-property-decorator";
import { championPick } from "@/store/index";
import { ActiveSynergy } from "@/models/type";

@Component({
  name: "champion-side-pick",
  components: {
    "active-synergy-item": () =>
      import("@/components/Organisms/SynergyCountItem.vue")
  }
})
export default class ChampionSideDeck extends Vue {
  get activeOriginSynergy(): ActiveSynergy[] {
    return [
      ...championPick.activeOriginSynergy,
      ...championPick.activeClassSynergy
    ]
      .filter(x => x.isActive)
      .sort((a, b) =>
        a.bonus!.tier === b.bonus!.tier ? 0 : a.bonus!.tier - b.bonus!.tier
      );
  }
  get inactiveOriginSynergy(): ActiveSynergy[] {
    return [
      ...championPick.activeOriginSynergy,
      ...championPick.activeClassSynergy
    ]
      .filter(x => !x.isActive)
      .sort((a, b) => (b.count === a.count ? 0 : b.count - a.count));
  }
}
